import toast from 'react-hot-toast';
import { translateWithCurrentLabels } from './current-hierarchy-text';

const TRANSLATED_METHODS = ['success', 'error', 'loading'] as const;

let installed = false;

export function showHierarchyNamesInToasts(): void {
  if (installed) return;
  installed = true;

  for (const method of TRANSLATED_METHODS) {
    const original = toast[method].bind(toast);
    toast[method] = ((message: Parameters<typeof original>[0], options?: Parameters<typeof original>[1]) =>
      original(
        typeof message === 'string' ? translateWithCurrentLabels(message) : message,
        options,
      )) as typeof original;
  }
}
